import { useState } from 'react';
import { isValidEmail } from '../../../../../../utils/helper';
import SavedAddresses from '../../../../../books/saved-address';
import SavedContacts from '../../../../../books/saved-contacts';
import UbbeCardHeader from '../../../../../global-components/cardHeader';
import CarriersSelect from '../../../carriersSelect';
import EditWHModal from './EditWHModal';

interface Props {
  formData: any;
  setFormData: any;
  setShowAddContactModal?: any;
  setShowAddAddressModal?: any;
  fetchData?: any;
}
function DetailSectionOthersSection({
  formData,
  setFormData,
  setShowAddContactModal,
  setShowAddAddressModal,
  fetchData,
}: Props) {
  const [editWH, seteditWH] = useState(false);
  function onCloseWHModal() {
    seteditWH(false);
  }
  const onClickWHHandler = () => {
    seteditWH(true);
  };
  return (
    <>
      <div className='col-12 col-md-6 mt-4'>
        <div className='ubbe-card h-auto'>
          <UbbeCardHeader
            headerText='Web-hooks'
            editable
            onClick={onClickWHHandler}
          />
          <div className='card-body px-4 py-2 h-100'>
            {editWH && (
              <EditWHModal
                formData={formData}
                setFormData={setFormData}
                onClose={onCloseWHModal}
                fetchData={fetchData}
                editContact={seteditWH}
              />
            )}
            <>
              <div
                className='row'
                style={{ width: '63.5%' }}
              >
                <div className='col'>
                  <span className='global-text-16'>
                    {' '}
                    Tracking Status Change:
                  </span>
                </div>
                <div
                  className='col-md-auto boldglobaltext'
                  id='origin_address'
                >
                  {formData?.webhook_tracking_change
                    ? formData?.webhook_tracking_change
                    : 'N/A'}
                </div>
              </div>
              <div
                className='row mt-3'
                style={{ width: '63.5%' }}
              >
                <div className='col'>
                  <span className='global-text-16'>
                    {' '}
                    Email (Default: User email above):
                  </span>
                </div>
                <div
                  className='col-md-auto boldglobaltext'
                  id='origin_address'
                >
                  {formData?.email ? formData?.email : 'N/A'}
                </div>
              </div>
            </>
          </div>
        </div>
        <div className='ubbe-card h-auto mt-4'>
          <div className='card-body px-4 py-3  h-100 my-auto'>
            <div className='row'>
              <div className='col-sm-12 col-md-6'>
                <div className='form-check'>
                  <input
                    className='form-check-input globalInputLabel'
                    type='checkbox'
                    id='is_active'
                    checked={formData?.is_active}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        is_active: e.target.checked,
                      });
                    }}
                  />
                  <label
                    className='form-check-label globalInputLabel'
                    style={{ fontWeight: '300' }}
                    htmlFor='is_active'
                  >
                    Is the user active?
                  </label>
                </div>
              </div>
              <div className='col-sm-12 col-md-6 mb-3'>
                <div className='form-check'>
                  <input
                    className='form-check-input globalInputLabel'
                    type='checkbox'
                    id='is_price_hide'
                    checked={formData?.is_price_hide}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        is_price_hide: e.target.checked,
                      });
                    }}
                  />
                  <label
                    className='form-check-label globalInputLabel'
                    style={{ fontWeight: '300' }}
                    htmlFor='is_price_hide'
                  >
                    Is the price hidden?
                  </label>
                </div>
              </div>
              <div className='col-sm-12 col-md-6'>
                <div className='form-check'>
                  <input
                    className='form-check-input globalInputLabel'
                    type='checkbox'
                    id='is_vendor'
                    checked={formData?.is_vendor}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        is_vendor: e.target.checked,
                      });
                    }}
                  />
                  <label
                    className='form-check-label globalInputLabel'
                    style={{ fontWeight: '300' }}
                    htmlFor='is_vendor'
                  >
                    Is the user a vendor?
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='col-12 col-md-6'></div>
      {/* only if the user is vendor in start */}
      {formData?.carriers && formData.is_vendor && (
        <div
          className='mt-4'
          id='vendor_carriers_div'
        >
          <div className='col-12'>
            <div className='ubbe-card'>
              <UbbeCardHeader
                headerText='  Vendor Carriers
            '
              />
              <div className='card-body pt-2 p-4'>
                <div className='row'>
                  <div className='col-12'>
                    <CarriersSelect
                      formData={formData}
                      setFormData={setFormData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <SavedAddresses
        otherSection
        setShowAddAddressModal={setShowAddAddressModal}
      />
      <SavedContacts
        otherSection
        setShowAddContactModal={setShowAddContactModal}
      />
    </>
  );
}

export default DetailSectionOthersSection;
